import { useTranslation } from 'react-i18next';

import {
    Flex, PaginationFirstButton, PaginationLastButton, PaginationNavGroup, PaginationNextButton,
    PaginationPageStatus, PaginationPrevButton
} from '@amzn/storm-ui';

export interface PaginationNavigationProps {
  id: string;
  currentPage: number;
  currentSize: number;
  totalItems: number;
  totalPages?: number;
  onPageChangeCb: (page: number) => void;
}

export const CustomPageNavigation = ({
  id,
  currentPage,
  currentSize,
  totalItems,
  totalPages: apiTotalPages,
  onPageChangeCb,
}: PaginationNavigationProps) => {
  const { t } = useTranslation();

  const totalPages = apiTotalPages ?? Math.ceil(totalItems / currentSize);
  const currentPageNumber = totalPages > 0 ? currentPage + 1 : 0;
  const pageText =
    totalPages !== 1
      ? t('pagination-page-plural')
      : t('pagination-page-singular');

  return (
    <Flex alignItems="center" columnGap="small">
      <PaginationPageStatus
        id={`${id}-status`}
        currentPageLabel={t('pagination-page-status', {
          currentPage: currentPageNumber,
          totalPages,
          pageText,
        })}
      />
      <PaginationNavGroup
        aria-controls={`${id}-status`}
        aria-labelledby={`${id}-status`}
      >
        <PaginationFirstButton
          id={`${id}-first`}
          ariaLabel={t('pagination-navigate-first')}
          onClick={() => onPageChangeCb(0)}
          disabled={currentPage === 0 || totalPages === 0}
        />
        <PaginationPrevButton
          id={`${id}-prev`}
          ariaLabel={t('pagination-navigate-previous')}
          onClick={() => onPageChangeCb(currentPage - 1)}
          disabled={currentPage === 0 || totalPages === 0}
        />
        <PaginationNextButton
          id={`${id}-next`}
          ariaLabel={t('pagination-navigate-next')}
          onClick={() => onPageChangeCb(currentPage + 1)}
          disabled={currentPage === totalPages - 1 || totalPages === 0}
        />
        <PaginationLastButton
          id={`${id}-last`}
          ariaLabel={t('pagination-navigate-last')}
          onClick={() => onPageChangeCb(totalPages - 1)}
          disabled={currentPage === totalPages - 1 || totalPages === 0}
        />
      </PaginationNavGroup>
    </Flex>
  );
};
